import { withAITracking } from '@microsoft/applicationinsights-react-js'
import React from 'react'
import { reactPlugin } from '../../applicationInsights'

const Dashboard = () => (
	<h1 style={{fontSize: '1.5em', fontWeight: 'bold'}}>Dashboard</h1>
)

export default withAITracking(reactPlugin, Dashboard, 'Dashboard')